<template>
    <div>
        <div class="modal fade" id="supportJm" tabindex="-1" aria-labelledby="supportJmLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-md">
                <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                    <div class="modal-header2 p-0" style="">
                        <h6 class="modal-title" id="exampleModalLabel">{{ type == 'newMessage' ? 'Contactar a Mesa de ayuda' :
                            'Respuesta de Mesa de ayuda' }}
                            <button id="closeSupportJm" :style="skin.my_account.close_btn" @click="closeChat"
                                style="background:transparent;float: right;color:white" type="button" class="btn-close"
                                data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                        </h6>
                    </div>
                    <div class="modal-body p-4">
                        <div v-if="loading" style="width:100%" class="text-center p-2">
                            <div class="spinner-border" style="color:beige" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="type == 'newMessage'">
                                <div class="col-10 offset-2 md-form mb-5 chat-body white z-depth-1 font-size-custom">
                                    <input type="text" id="ModalNewTicketSubject" v-model="subject"
                                        class="form-control new-ticket-input modal-clear-val" placeholder="Asunto"
                                        autocomplete="off" maxlength="64">
                                </div>
                                <div class="d-flex">
                                    <div class="col-2 md-form px-0 file-field" id="ModalNewTicketAttachDiv">
                                        <input type="file" ref="imageInput" @change="handleImageUpload" style="display: none;" accept="image/*">
                                        <div class="btn btn-floating float-left m-2 my-3 btn-image">
                                            <i class="fas fa-paperclip icon" @click="triggerImageUpload"></i>
                                        </div>
                                    </div>
                                    <div class="col-10 md-form amber-textarea active-amber-textarea mt-3 chat-body white z-depth-1 font-size-custom ml-1 ml-sm-0"
                                        id="ModalNewTicketReply">
                                        <textarea placeholder="Ingrese aqui el mensaje" id="ModalNewTicketMessage" v-model="message"
                                            class="md-textarea form-control" rows="3"></textarea>
                                    </div>
                                </div>
                                <div class="p-0" style="text-align: end;"><span style="font-size: x-small;">{{ image_name }}</span></div>
                            </div>
                            <div v-else-if="type.descripcion" class="col-12 px-0 py-3">
                                <div class="">
                                    <ul class="list-unstyled chat chat-message" style="display: block;">
                                        <li class="mb-4" v-for="(message, index) in JSON.parse(type.descripcion)" :key="index">
                                            <div v-if="message.sender==user.user_data.data.username" class="row">
                                                <div class="col-2"></div>
                                                <div class="col-9 chat-body chat-own-message white p-2 me-2 z-depth-1">
                                                    <div class="header"></div>
                                                    <p class="mb-0">{{ message.message }}</p>
                                                    <p v-if="message.image">
                                                        <img :src="message.image" alt="" style="max-width: 250px">
                                                    </p>
                                                    <div style="width: 100%;height: 20px;">
                                                        <small class="float-end"><svg
                                                            class="message-check" data-message-id="0"
                                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15"
                                                            width="16" height="15">
                                                            <path :fill="message.leido_gplus_uid == 0 ? '#4FC3F7' : 'grey'"
                                                                d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z">
                                                            </path>
                                                        </svg> {{ formatearFecha(message.date) }}</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="col-10 chat-body white p-2 z-depth-1">
                                                    <div class="header"><strong>{{ message.sender.includes("soporte") ?  "Asistente" : "Agente"}}</strong></div>
                                                    <hr style="color: rgb(73, 72, 72);" class="w-100">
                                                    <p class="mb-0" style="color: black;">{{ message.message }}</p>
                                                    <p v-if="message.image">
                                                        <img :src="message.image" alt="" style="max-width: 250px">
                                                    </p>
                                                    <div style="width: 100%;height: 20px;">
                                                        <small class="float-end" style="color: rgb(73, 72, 72);">
                                                            {{ formatearFecha(message.date) }}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="d-flex">
                                        <div class="col-2 md-form px-0 file-field" id="ModalReplyTicketAttachDiv"
                                            style="display: block;">
                                            <div class="col-2 md-form px-0 file-field" id="ModalNewTicketAttachDiv">
                                                <div class="btn btn-floating float-left m-2 my-3 btn-image">
                                                    <i class="fas fa-paperclip icon" @click="triggerImageUpload"></i>
                                                    <input type="file" ref="imageInput" @change="handleImageUpload" style="display: none;" accept="image/*">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-10 md-form amber-textarea active-amber-textarea mt-3 chat-body white z-depth-1 font-size-custom ml-1 ml-sm-0"
                                            id="ModalReplyTicketReply" style="display: block;">
                                            <textarea id="ModalReplyTicketMessage" placeholder="Respuesta" class="md-textarea form-control" v-model="message"
                                                rows="2"></textarea>
                                        </div>
                                    </div>
                                    <div class="p-0" style="text-align: end;"><span style="font-size: x-small;">{{ image_name }}</span></div>
                                </div>
                            </div>
                        </div><br>
                        <div class="text-center">
                            <button class="btn me-3" style="background-color: #292d3d;color:white" data-bs-dismiss="modal" @click="closeChat"
                                aria-label="Close">Cancelar</button>
                            <button :disabled="loading || message ==''" @click="type == 'newMessage' ? createTicket() : replyTicket()" class="btn" style="background-color: #292d3d;color:white">{{ type == 'newMessage' ? 'Enviar' :
                            'Responder' }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
export default {
    name: "support",
    props: ['skin', 'translation', 'language', 'type'],
    components: {},
    data() {
        return {
            loading: false,
            subject:"",
            message:"",
            image_src:"",
            image_name:""
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
    },
    methods: {
        async getData() {
            this.loading = true;
            let data = await axios.post("https://reportes." + this.user.domain.split("admin.")[1] +"/historial_jugador", {
                "username": this.user.user_data.data.username,
                "startDate": "2020-01-01 00:00:00",
                "endDate": "2030-12-31 23:59:59"
            })
            this.loading = false;
        },
        async createTicket(){
            this.loading = true
            await axios.post("https://reportes." + this.user.domain.split("admin.")[1] +"/soporte", {
                "asunto":  this.subject,
                "descripcion": this.message,
                "image": this.image_src,
                "login_Id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                "estado":  1, 
                "gplus_uid":1001
            })
            this.loading = false
            this.subject = "";
            this.message = "";
            this.image_name = "";
            this.image_src = "";
            this.$root.$emit('loadSupportModal');
            document.getElementById('closeSupportJm').click();
        },
        async replyTicket(){
            this.loading = true
            await axios.post("https://reportes." + this.user.domain.split("admin.")[1] +"/respuesta_soporte", {
                "ticket":  this.$props.type.id,
                "descripcion": this.message,
                "image": this.image_src,
                "login_Id": this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                "estado":  1
            })
            this.loading = false
            this.subject = "";
            this.message = "";
            this.image_name = "";
            this.image_src = "";
            this.$root.$emit('loadSupportModal');
            document.getElementById('closeSupportJm').click();
        },
        triggerImageUpload() {
            this.$refs.imageInput.click();  // Activa el input de tipo "file"
        },
        closeChat(){
            this.subject = "";
            this.message = "";
            this.image_name = "";
            this.image_src = "";
        },
        compressImage(imgToCompress, resizingFactor = 0.3, quality = 0.5) {
            // resizing the image
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            
            const originalWidth = imgToCompress.width;
            const originalHeight = imgToCompress.height;
            
            const canvasWidth = originalWidth * resizingFactor;
            const canvasHeight = originalHeight * resizingFactor;
            
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            
            context.drawImage(
                imgToCompress,
                0,
                0,
                originalWidth * resizingFactor,
                originalHeight * resizingFactor
            );
            
            // reducing the quality of the image
            const self = this;
            canvas.toBlob(
                (blob) => {
                if (blob) {
                    var reader = new FileReader();
                    reader.readAsDataURL(blob); 
                    reader.onloadend = function() {
                        var base64data = reader.result;      
                        self.image_src = base64data; // AQUI ESTA EL BASE 64 RESULTANTE
                    }
                }
                },
                "image/jpeg",
                quality
            );
        },
        handleImageUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                // Aquí reducimos la calidad de la imagen antes de convertirla en Data URL
                const image = new Image();
                image.src = e.target.result;
                // console.log(file.name)
                this.image_name = file.name;
                const self = this;
                image.onload = () => {
                    self.compressImage(image)
                };
                };
                reader.readAsDataURL(file);
            }
        },
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
    },
    mounted() {

    }
}
</script>
  
<style scoped>.modal-header2 {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: -1.25rem !important;
    margin-bottom: 0 !important;
    height: 60px;
    padding: 1rem !important;
    color: #fff;
    border-bottom: none;
    background: linear-gradient(40deg, #292d3d, #03040d) !important
}
.white {
    background-color: #fff!important;
}
.btn-image {
    background-color: #292d3d !important;
    color: #fff;
    font-family: "metropolisregular" !important;
}
.justify-content-between {
    -ms-flex-pack: justify!important;
    justify-content: space-between!important;
}
.chat-own-message {
    background-color: #292d3d!important;
}
.chat-body .header strong {
    color: coral;
    font-weight: 500;
}
.chat-body {
    border-radius: 0.4rem!important;
    overflow-wrap: break-word;
}
.btn-floating {
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, .18), 0 4px 15px 0 rgba(0, 0, 0, .15);
    width: 47px;
    height: 47px;
    position: relative;
    z-index: 1;
    vertical-align: middle;
    display: inline-block;
    overflow: hidden;
    -o-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    margin: 10px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
}
.chat-message{
    max-height: 40vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.icon {
    font-size: large;
    margin-top: 15px;
    margin-bottom: 15px;
}

.list-unstyled.chat {
    font-size: 14.2px !important;
    font-weight: 400 !important;
    font-family: Segoe UI !important;
    display: none;
}

.list-unstyled {
    padding-left: 0;
    list-style: none;
}</style>